module.exports = __webpack_public_path__ + "static/media/linkedin_icon.57120c60.svg";